import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const DurationStyles: moduleStyleType = {
    error: {
        borderColor: 'error.main',
    },
    numberInput: {
        backgroundColor: 'background.default',
        width: '10ch',
    },
}
